import { tooltipClasses } from '@zenbusiness/zui/Tooltip';

export const TooltipStyle = ({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    ...theme.typography.xs,
    height: '32px',
    padding: '8px 14px',
    borderRadius: '12px',
    backgroundColor: theme.palette.fixed.black
  }
});
